export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145">
    <path d="M81.2 54.2C71.1 41.3 59.5 26.7 54.9 3.7 54.5 1.6 52.6 0 50.5 0c-2.2 0-4 1.6-4.4 3.7C41.6 28 29.8 42.6 19.4 55.5 9.7 67.5.5 78.8.5 94.9c0 27.6 22.4 50 50 50s50-22.4 50-50c0-16.4-9.4-28.2-19.3-40.7zm-12.4 74.3c-.7.3-1.4.5-2.1.5-1.6 0-3.2-.9-4-2.4-1.1-2.2-.3-4.9 1.9-6.1 5.2-2.7 14-9.1 15-21.9.2-2.5 2.4-4.3 4.8-4.1 2.5.2 4.3 2.4 4.1 4.8-1.3 17.1-12.9 25.6-19.7 29.2z" />
  </svg>
);
